// extracted by mini-css-extract-plugin
export default {"newsletter":"page7_newsletter__PCBpi"};